
require('./libs/plugins/clipboard');
require('./libs/plugins/sort-items');
require('./libs/plugins/phonenumber-formatter');
require('./libs/plugins/toggle-related-fields');
require('./libs/plugins/textfield-sign-counter');
